import { render, staticRenderFns } from "./PlantsListComponent.vue?vue&type=template&id=3f8e8b70&"
import script from "./PlantsListComponent.vue?vue&type=script&lang=js&"
export * from "./PlantsListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports